import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { SERVICE_URL } from "../../_urls/service.urls";

@Injectable({ providedIn: "root" })
export class PermissionsService {
  constructor(private http: HttpClient) {}

  getModulePermissionsByRole(role: string): Observable<any> {
    const url = `${environment.clfApiBaseUrl}api/clf-profile/v1/clf-profile/module-permissions/by-role`;
    return this.http.get(url, { params: { role }, observe: "body" });
  }

  getUserPermissions(sub: string): Observable<string[]> {
    const url = `${environment.keyClockApiBaseUrl}${SERVICE_URL.KEYCLOAK_REALMS}${environment.keycloak.realm}/permission/${sub}`;
    return this.http.get<string[]>(url, { observe: "body" });
  }
}
